document.addEventListener('DOMContentLoaded', () => {
  const footerContent = document.querySelector('[data-accordion-mobile]');
  if (footerContent) {
    const wrap = () => {
      footerContent.querySelectorAll('.group--vertical').forEach(group => {
        if (group.closest('responsive-accordion')) return;
        const wrapper = document.createElement('responsive-accordion');
        wrapper.className = 'footer__responsive-accordion';
        const parent = group.parentNode;
        const next = group.nextSibling;
        wrapper.appendChild(group);
        parent.insertBefore(wrapper, next);
      });
    };

    if (customElements.get('responsive-accordion')) {
      wrap();
    } else {
      customElements.whenDefined('responsive-accordion').then(wrap);
    }
  }

  document.querySelectorAll('[data-scroll-top]').forEach(btn => {
    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
});
